import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos() {
        let url = `${api}/fornecedores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDashboard(id) {
        return axiosJwt
            .get(`${api}/fornecedores/${id}/dashboard`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDados(id) {
        let url = `${api}/fornecedores/${id}/dadoscadastrais`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentosRm(id, filtro) {
        let url = `${api}/fornecedores/${id}/pagamentos?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportarPagamentos(id, exportacao) {
        let url = `${api}/fornecedores/${id}/pagamentos/exportar?dataInicial=${exportacao.dataInicial}
        &dataFinal=${exportacao.dataFinal}&status=${exportacao.status}&tipo=${exportacao.tipo}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprovante(reciboDto) {
        let url = `${api}/fornecedores/${reciboDto.fornecedorId}/pagamentos/comprovante?id=${reciboDto.id}&comprovante=${reciboDto.comprovante}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnosCalendario(id) {
        let url = `${api}/fornecedores/${id}/dirf/anoscalendario`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDirf(id, ano) {
        let url = `${api}/fornecedores/${id}/dirf/${ano}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRendimentos(id, fornecedorId) {
        let url = `${api}/fornecedores/${fornecedorId}/dirf/${id}/rendimentos`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentos(id, fornecedorId) {
        let url = `${api}/fornecedores/${fornecedorId}/dirf/${id}/pagamentos`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterContratos(id) {
        let url = `${api}/fornecedores/${id}/contratos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCertidoes(id) {
        let url = `${api}/fornecedores/${id}/certidoes`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRequisicoes(fornecedorId, codContrato) {
        let url = `${api}/fornecedores/${fornecedorId}/contratos/${codContrato}/requisicoes`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRequisicao(fornecedorId, codContrato, idRequisicao) {
        let url = `${api}/fornecedores/${fornecedorId}/contratos/${codContrato}/requisicoes/${idRequisicao}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorCpfCnpj(cpfCnpj) {
        let url = `${api}/fornecedores/${cpfCnpj}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarLogo(cpfCnpj, logo) {
        const url = `${api}/fornecedores/cpfcnpj/${cpfCnpj}/logo`
        return axiosJwt
            .put(url, { logo })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterLogo(cpfCnpj) {
        const url = `${api}/fornecedores/cpfcnpj/${cpfCnpj}/logo`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                // Em caso de 404 (sem logo), não tratar como um erro global
                if (error.response && error.response.status === 404) {
                    return { success: false, message: 'Logo not found.' };
                }
                return errorHandler(error)
            })
    },
}
